module.exports = __webpack_public_path__ + "img/news14_2.62b0a0ec.jpg";